export default {"src":"/_next/static/media/wordpress.9f06d992.svg","height":255,"width":256,"blurWidth":0,"blurHeight":0};